<script setup lang="ts">
import Seller from '../common/seller.vue';
import { useProductPage } from '../../business/use-product-page';
import { computed } from 'vue';

const { state } = useProductPage();
const product = computed(() => state.product);
const sellerData = computed(() => {
  if (!product?.value?.seller) return {};

  return {
    ...product.value.seller,
    reviews: product.value.seller.feedbackQuantity,
  };
});
</script>

<template>
  <Seller :seller="sellerData" />
</template>
